<template>
    <div>
        <h1 class="title is-4">
            {{title}}
        </h1>
        <slot></slot>
    </div>
</template>
<script>
export default {
    props:["title"]
}
</script>